import PackageCurrencyAmount from "../PackageCurrencyAmount";

const TotalCalculation = ({ totals, cadTotals, showCadAmount = false }) => {
  const currencySuffix = " per month";

  return (
    <div className="card mb-2 totals">
      <div className="card-body">
        <div className="row justify-content-end mb-2">
          <div className="col-6 col-lg-3 col-xl-2 title">Media Fee:</div>
          <div className="col-6 col-lg-3 text-right val">
            <PackageCurrencyAmount
              value={totals.totalMediaAmount}
              cadValue={cadTotals?.totalMediaAmount}
              showCadAmount={showCadAmount}
              suffix={currencySuffix}
            />
          </div>
        </div>
        <div className="row justify-content-end mb-2">
          <div className="col-6 col-lg-3 col-xl-2 subs">Fee:</div>
          <div className="col-6 col-lg-3 text-right subs">
            <PackageCurrencyAmount
              value={totals.totalSubscriptingFee}
              cadValue={cadTotals?.totalSubscriptingFee}
              showCadAmount={showCadAmount}
              suffix={currencySuffix}
            />
          </div>
        </div>

        <div className="row justify-content-end">
          <div className="col-6 col-lg-3 col-xl-2 total_title">
            Total to Pay:
          </div>
          <div className="col-6 col-lg-3 text-right total_val">
            <PackageCurrencyAmount
              value={totals.total}
              cadValue={cadTotals?.total}
              showCadAmount={showCadAmount}
              suffix={currencySuffix}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalCalculation;
